import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaNotesMedical, FaStethoscope, FaCalendarCheck, FaBriefcaseMedical, FaAmbulance, FaHospitalUser, FaUserShield, FaCapsules, FaMicroscope, FaPrescriptionBottleAlt, FaLaptopMedical,} from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/medical.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "icon": "<FaNotesMedical className='text-[#2a627a] text-3xl' />",
        "title": "Electronic Health Records (EHR)",
        "description": "A secure, cloud-based digital repository containing comprehensive patient data, including medical history, diagnoses, treatments, prescriptions, allergies, and lab results. EHRs facilitate seamless information sharing between healthcare providers, reduce medical errors, and enhance clinical decision-making by ensuring real-time, up-to-date access to patient records across multiple facilities."
    },
    {
        "icon": "<FaClipboardList className='text-[#2a627a] text-3xl' />",
        "title": "Medical History & Reports",
        "description": "Detailed documentation of past illnesses, surgeries, chronic conditions, allergies, immunization records, and genetic predispositions. This information is crucial for early disease detection, personalized treatment planning, and tracking long-term health trends to improve preventive care strategies."
    },
    {
        "icon": "<FaFileMedicalAlt className='text-[#2a627a] text-3xl' />",
        "title": "Lab & Diagnostic Reports",
        "description": "Automated integration of laboratory test results, including blood tests, biopsies, urine analysis, and imaging scans such as X-rays, MRIs, CT scans, and ultrasounds. Quick access to these reports enables physicians to make timely and accurate diagnoses, monitor disease progression, and share results with specialists for collaborative patient care."
    },
    {
        "icon": "<FaUserMd className='text-[#2a627a] text-3xl' />",
        "title": "Doctor Consultation Records",
        "description": "Detailed physician notes from medical visits, including symptoms, diagnoses, prescribed treatments, and follow-up care recommendations. This ensures continuity of care by allowing multiple healthcare providers to track patient progress, avoid redundant tests, and tailor treatments to individual patient needs."
    },
    {
        "icon": "<FaFileInvoice className='text-[#2a627a] text-3xl' />",
        "title": "Billing & Insurance Claims",
        "description": "Comprehensive records of medical expenses, invoices, insurance claims, and payment transactions. This system simplifies billing transparency, allows patients to track their healthcare costs, and accelerates insurance reimbursements by integrating with provider networks for automated claim processing and approvals."
    },
    {
        "icon": "<FaBriefcaseMedical className='text-[#2a627a] text-3xl' />",
        "title": "Emergency Medical Information",
        "description": "Instant access to life-saving patient data, including blood type, allergies, pre-existing conditions, current medications, and emergency contacts. This information is vital for emergency responders and hospital teams, allowing them to provide immediate and informed care in critical situations, reducing response time and preventing medical complications."
    },
    {
        "icon": "<FaPrescriptionBottleAlt className='text-[#2a627a] text-3xl' />",
        "title": "Medication & Prescription Records",
        "description": "A secure, digital record of prescribed medications, dosages, refill schedules, and potential drug interactions. Ensures patient adherence to treatment plans, reduces the risk of medication errors, prevents adverse drug reactions, and allows healthcare providers to monitor prescription history for optimal medication management."
    }
]

const features = [
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Efficient digital documentation for quick access to patient records." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Improved accuracy with structured medical data storage." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Enhanced patient safety with real-time health monitoring." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Integrated medication tracking and drug interaction alerts." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Easy access to lab results and diagnostic reports." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Secure and compliant storage of medical records." }
];

const benefits = [
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Faster and more efficient patient care with digital records." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Reduced paperwork and administrative workload for healthcare providers." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Seamless coordination between multiple healthcare providers." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Automated appointment scheduling and follow-up reminders." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Data encryption and privacy protection for sensitive medical information." },
    { icon: <FaAmbulance className="text-[#2a627a] text-lg" />, text: "Quick access to emergency medical records for critical care situations." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,

        text: "Access and update patient records, prescribe medications, and coordinate care with specialists."
    },
    {
        icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />,

        text: "Monitor patient vitals, update treatment progress, and assist in patient documentation."
    },
    {
        icon: <FaStethoscope className="text-[#2a627a] text-lg" />,

        text: "Handle patient intake, document symptoms, and update medical history records."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,

        text: "Ensure accurate documentation, manage patient records, and maintain data security compliance."
    },
    {
        icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />,

        text: "Review and manage patient medication history for safe and effective treatment plans."
    },
    {
        icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />,

        text: "Oversee EHR system management, data security, and seamless integration with healthcare services."
    }
];

const MedicalRecords = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Medical Records  - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Ensuring accuracy, confidentiality, and accessibility to support quality patient care and compliance."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What are Medical Records?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Medical records store a patient’s health history, including diagnoses, treatments, medications, and test results, ensuring accurate and continuous care.

                            At HIKEHEALTH GS, we provide secure, digital medical record solutions for seamless access, better coordination, and improved patient outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Medical Records
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default MedicalRecords;
